<template>
  <div class="home">
    <nav-bar :navigationIndex="0" />
    <div class="home_main">
      <div id="app" ref="appRef">
        <div class="carousel no-select">
          <div class="w_1280">
            <div class="carousel_top_title" v-html="topInfo.name">
            </div>
            <div class="carousel_text" v-html="topInfo.content">
            </div>
            <div class="carousel_btn flex_center cursor">了解更多</div>
          </div>

          <div class="slide_icon">
            <img class="shake" src="@/assets/images/slideIcon.png" alt="" />
          </div>
        </div>
        <div class="home_main_first">
          <div class="column_title_box w_1280 no-select">
            <div class="title_txt">{{ homeFirstInfo.nickName }}</div>
            <div class="title_name">{{ homeFirstInfo.name }}</div>
          </div>

          <div class="first_main flex_between w_1280">
            <div class="first_main_left">
              <div class="first_left_title no-select">{{ homeFirstInfo.title }}</div>
              <div class="first_left_text no-select">
                {{ homeFirstInfo.content }}
              </div>
              <div class="first_left_list">
                <div class="first_left_list_tabs flex">
                  <div class="flex_center flex_column cursor" :class="firstTypeId == index
                    ? 'left_list_tabs_box_select'
                    : 'left_list_tabs_box'
                    " v-for="(item, index) in homeFirstInfo.typeList" :key="index"
                    @click="changeFirstType(item, index)">
                    {{ item.name }}
                    <div :class="firstTypeId == index
                      ? 'tabs_box_line_select'
                      : 'tabs_box_line'
                      "></div>
                  </div>
                </div>

                <div class="flex no-select">
                  <div class="left_number_box" v-for="(item, index) in firstInfoList" :key="index">
                    <div class="left_number_num">
                      {{ item.value }} <span>{{ item.unit }}</span>
                    </div>
                    <div class="left_number_text">
                      {{ item.label }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="first_main_right flex no-select">
              <img src="@/assets/images/homeFirstImg2.png" alt="" />
              <img class="right_img_two" src="@/assets/images/homeFirstImg.png" alt="" />
            </div>
          </div>
        </div>

        <div class="home_main_two">
          <div class="flex_between w_1280">
            <div class="column_title_box color_fff no-select">
              <div class="title_txt">INDUSTRY GRAPH</div>
              <div class="title_name">产业图谱</div>
            </div>
            <div class="cursor graph_btn flex_center" @click="toAllGraph">查看全部</div>
          </div>
          <div>
            <graph></graph>
          </div>
        </div>

        <div class="home_main_three">
          <div class="column_title_box w_1280 no-select">
            <div class="title_txt">{{ industryDevelopment.nickName }}</div>
            <div class="title_name">{{ industryDevelopment.name }}</div>
          </div>
          <div class="w_1280">
            <div class="scale_list flex_center no-select">
              <div class="scale_box flex_center flex_column" v-for="(item, index) in scaleInfo" :key="index">
                <div class="scale_num">{{ item.value }} <span>{{ item.unit }}</span></div>
                <div class="scale_name">{{ item.label }}</div>
              </div>
            </div>
          </div>
          <div class="select_year_box no-select">
            {{ currentYear }}
          </div>
          <div class="flex_center">
            <div class="left_time_line"></div>
            <div class="time_line_main flex_center">
              <div class="time_line_btn cursor flex_center" @click="changeLeft">
                <el-icon>
                  <ArrowLeftBold />
                </el-icon>
              </div>
              <div class="center_time_line"></div>
              <div class="time_line_btn cursor flex_center" @click="changeRight">
                <el-icon>
                  <ArrowRightBold />
                </el-icon>
              </div>
            </div>
            <div class="right_time_line"></div>
          </div>
          <div class="time_line_list flex_center">
            <div class="time_line_box cursor flex_center flex_column"
              v-for="(item, index) in industryDevelopment.dataList" :key="index" @click="changeYear(item, index)">
              <div class="" :class="currentYear == item.date ? 'time_line_drop_select' : 'time_line_drop'">
              </div>
              <div class="" :class="currentYear == item.date ? 'time_line_year_select' : 'time_line_year'">
                {{ item.date }}
              </div>
            </div>
          </div>
        </div>

        <div class="home_main_four">
          <div class="flex_between w_1280">
            <div class="column_title_box color_fff no-select">
              <div class="title_txt">{{ industryNewsInfo.nickName }}</div>
              <div class="title_name">{{ industryNewsInfo.name }}</div>
            </div>
            <div class="cursor graph_btn flex_center" @click="goPage('/newsInformationPage')">查看全部</div>
          </div>
          <div class="news_list flex_between w_1280">
            <div class="news_box cursor" v-for="item in industryNewsInfo.jyskArticleList" :key="item.id"
              @click="goDetail(item)" @mouseenter="newMouseEnter(item.id)" @mouseleave="newMouseLeave">
              <div class="news_title_box flex_between color_fff">
                <div class="news_title text_overflow">{{ item.title }}</div>
                <div>
                  <el-icon>
                    <Right />
                  </el-icon>
                </div>
              </div>
              <div class="news_text_box color_fff">
                <div :class="newsId == item.id ? 'new_line_select' : 'new_line'"></div>
                <div class="news_content multi_line_ellipsis3">
                  {{ item.introduce }}
                </div>
                <div class="news_img">
                  <img :src="item.imgPathUrl" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="home_main_five">
          <div class="column_title_box w_1280 no-select">
            <div class="title_txt">{{ industryChronicleInfo.nickName }}</div>
            <div class="title_name">{{ industryChronicleInfo.name }}</div>
          </div>
          <div class="w_1280">
            <div class="memorabilia_tabs_list flex_end">
              <div class="cursor"
                :class="industryChronicleIndex == index ? 'memorabilia_tabs_select' : 'memorabilia_tabs_box'"
                v-for="(item, index) in industryChronicleInfo.lineList" :key="index"
                @click="selectIndustryChronicle(item, index)">
                {{ item.name }}
              </div>
            </div>
            <div class="poetry-timeline-container">
              <div class="timeline_head"></div>
              <div v-for="(item, index) in timelineData" :key="index" class="timeline-item">
                <div class="left-poetry">
                  <p class="poetry-year">{{ item.date }}</p>
                </div>
                <div class="timeline-line full-line"></div>
                <div class="right-poetry">
                  <div class="poetry_title text_overflow">{{ item.title }}</div>
                  <div class="poetry-content">{{ item.event }}</div>
                  <div class="poetry-content">{{ item.effect }}</div>
                </div>
              </div>
              <div class="timeline_head"></div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <bottom-bar></bottom-bar>
  </div>
</template>

<script>
import RelationGraph from 'relation-graph-vue3';
import { topInfo, industryIntroduce, industryDevelopment, homeArticleList, industryChronicle, diagramList } from "@/utils/homeApi";
// @ is an alias to /src
import graph from './components/graph.vue';

export default {
  name: "HomePage",
  components: {
    RelationGraph,
    graph
  },
  data() {
    return {
      topInfo: {},

      currentScreen: 0, // 当前所在屏幕的索引
      isScrolling: false, // 标记是否正在滚动
      scrollDuration: 700, // 滚动动画的持续时间（毫秒）
      wheelAccumulator: 0, // 触控板滚动累积量

      homeFirstInfo: {},

      firstTypeId: 0,
      firstInfoList: [],
      industryDevelopment: {},
      scaleInfo: [],
      currentYear: 2019,
      startIndex: 0,

      industryNewsInfo: {},
      newsId: "",

      industryChronicleInfo: {},
      timelineData: [],
      industryChronicleIndex: 0,

      chartType: 0,
      chartTypeTwo: 0,
      chartTypeList: [4, 5, 6, 7, 8, 9, 10, 11, 12],
    };
  },
  mounted() {
    if (window.pageYOffset > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    // 监听滚轮事件
    window.addEventListener("wheel", this.handleWheel, true);

    this.getBasicInfo();
    this.getIndustryDevelopment();
    this.getIndustryChronicle();
  },
  beforeUnmount() {
    // 组件销毁前移除滚轮事件监听器
    window.removeEventListener("wheel", this.handleWheel, true);
  },
  methods: {
    // 锂电池点击方法
    selectGraphChartTwo() {
      if (this.chartTypeList.includes(11) && this.chartTypeList.includes(12)) {
        this.selectGraphChart(11);
        this.selectGraphChart(12);
      } else if (this.chartTypeList.includes(11)) {
        this.selectGraphChart(11);
      } else if (this.chartTypeList.includes(12)) {
        this.selectGraphChart(12);
      } else {
        this.selectGraphChart(11);
        this.selectGraphChart(12);
      }


    },
    // 除锂电池之外的点击方法
    selectGraphChart(type) {
      if (this.chartTypeList.includes(type)) {
        let index = this.chartTypeList.indexOf(type);
        this.chartTypeList.splice(index, 1);

        // 预焙阳极分支---子集收起
        if (type == 8) {
          let index = this.chartTypeList.indexOf(9);
          if (index >= 0) {
            this.chartTypeList.splice(index, 1);
          }
        }

        if (type == 7) {
          let index1 = this.chartTypeList.indexOf(8);
          if (index1 >= 0) {
            this.chartTypeList.splice(index1, 1);
          }

          let index2 = this.chartTypeList.indexOf(9);
          if (index2 >= 0) {
            this.chartTypeList.splice(index2, 1);
          }
        }

        // 负极材料---子集收起
        if (type == 10) {
          let index1 = this.chartTypeList.indexOf(11);
          if (index1 >= 0) {
            this.chartTypeList.splice(index1, 1);
          }

          let index2 = this.chartTypeList.indexOf(12);
          if (index2 >= 0) {
            this.chartTypeList.splice(index2, 1);
          }
        }

        if (type == 6) {
          let index3 = this.chartTypeList.indexOf(10);
          if (index3 >= 0) {
            this.chartTypeList.splice(index3, 1);
          }
          let index1 = this.chartTypeList.indexOf(11);
          if (index1 >= 0) {
            this.chartTypeList.splice(index1, 1);
          }

          let index2 = this.chartTypeList.indexOf(12);
          if (index2 >= 0) {
            this.chartTypeList.splice(index2, 1);
          }
        }
      } else {
        this.chartTypeList.push(type);
        // 预焙阳极分支---子集展开
        if (type == 8) {
          this.chartTypeList.push(9);
        }

        if (type == 7) {
          this.chartTypeList.push(8);
          this.chartTypeList.push(9);
        }

        // 负极材料---子集展开
        if (type == 10) {
          this.chartTypeList.push(11);
          this.chartTypeList.push(12);
        }

        if (type == 6) {
          this.chartTypeList.push(10);
          this.chartTypeList.push(11);
          this.chartTypeList.push(12);
        }
      }
    },
    graphEnter(type) {
      // this.chartType = type;
    },
    chartLeave() {
      // this.chartType = 0;
      // this.chartTypeTwo = 0;
    },
    handleWheel(event) {
      // 防止在滚动动画进行时重复触发
      if (this.isScrolling) return

      // 阻止默认滚动
      event.preventDefault()

      // 触控板/高精度滚轮：累积 delta 值，超过阈值才触发翻页
      const absDelta = Math.abs(event.deltaY)
      if (absDelta < 40) {
        // 低精度鼠标滚轮（delta 通常 ±100~120），直接触发
        this.wheelAccumulator = 0
        this.tryPageScroll(Math.sign(event.deltaY))
        return
      }
      // 高精度触控板：累积后触发
      this.wheelAccumulator += event.deltaY
      const threshold = 120
      if (Math.abs(this.wheelAccumulator) >= threshold) {
        const direction = Math.sign(this.wheelAccumulator)
        this.wheelAccumulator = 0
        this.tryPageScroll(direction)
      }
    },
    tryPageScroll(direction) {
      const screens = this.$refs.appRef.children
      const totalScreens = screens.length

      if (direction > 0 && this.currentScreen < totalScreens - 1) {
        this.currentScreen++
        this.scrollToScreen(this.currentScreen)
      } else if (direction < 0 && this.currentScreen > 0) {
        this.currentScreen--
        this.scrollToScreen(this.currentScreen)
      }
    },
    // easeInOutCubic 缓动函数：加速→匀速→减速
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
    },
    scrollToScreen(index) {
      this.isScrolling = true

      const screens = this.$refs.appRef.children
      const targetElement = screens[index]
      if (!targetElement) {
        this.isScrolling = false
        return
      }

      const startPosition = window.pageYOffset
      const targetPosition = targetElement.offsetTop
      const distance = targetPosition - startPosition

      // 位移太小无需动画，直接跳转
      if (Math.abs(distance) < 2) {
        this.isScrolling = false
        return
      }

      const startTime = performance.now()

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime
        if (elapsed < this.scrollDuration) {
          const rawProgress = elapsed / this.scrollDuration
          const easedProgress = this.easeInOutCubic(rawProgress)
          window.scrollTo(0, startPosition + distance * easedProgress)
          requestAnimationFrame(animate)
        } else {
          // 动画结束，精确到位
          window.scrollTo(0, targetPosition)
          this.isScrolling = false
        }
      }

      requestAnimationFrame(animate)
    },

    // 选择大事记类型，传递数据
    selectIndustryChronicle(rows, index) {
      this.timelineData = rows.dataList;
      this.industryChronicleIndex = index;
    },

    // 产业大事记信息
    async getIndustryChronicle() {
      let res = await industryChronicle();
      if (res.code == 200) {
        this.industryChronicleInfo = res.data;
        this.timelineData = res.data.lineList[0].dataList
      }
    },

    // 产业介绍左侧底部切换
    changeFirstType(rows, index) {
      this.firstTypeId = index;
      this.firstInfoList = rows.dataList;
    },

    // 产业发展规模时间轴切换
    changeLeft() {
      if (this.startIndex > 0) {
        this.startIndex--;
        this.currentYear = this.industryDevelopment.dataList[this.startIndex].date;
        this.scaleInfo = this.industryDevelopment.dataList[this.startIndex].dataList;
      }
    },
    changeRight() {
      if (this.startIndex < this.industryDevelopment.dataList.length - 1) {
        this.startIndex++;
        this.currentYear = this.industryDevelopment.dataList[this.startIndex].date;
        this.scaleInfo = this.industryDevelopment.dataList[this.startIndex].dataList;
      }
    },
    changeYear(rows, index) {
      this.currentYear = rows.date;
      this.startIndex = index;
      this.scaleInfo = rows.dataList;
    },
    // 产业发展规模
    async getIndustryDevelopment() {
      let res = await industryDevelopment();
      if (res.code == 200) {
        this.industryDevelopment = res.data;
        this.scaleInfo = res.data.dataList[0].dataList;
        this.currentYear = res.data.dataList[0].date;
      }
    },

    // 首页基本信息列表
    async getBasicInfo() {
      let res1 = await topInfo();
      if (res1.code == 200) {
        this.topInfo = res1.data;
      }

      let res2 = await industryIntroduce();
      if (res2.code == 200) {
        this.homeFirstInfo = res2.data;
        this.firstInfoList = res2.data.typeList[0].dataList
      }

      let res3 = await homeArticleList({
        type: 1,
      });
      if (res3.code == 200) {
        this.industryNewsInfo = res3.data;
      }

      let res4 = await diagramList();
      if (res4.code == 200) {
        // this.listDiagramInfo = res4.data;

      }
    },


    newMouseEnter(id) {
      this.newsId = id;
    },
    newMouseLeave() {
      this.newsId = 0;
    },

    // 查看新闻详情
    goDetail(item) {
      window.open(
        this.$router.resolve({
          path: '/listDetails',
          query: {
            id: item.id,
            typeValue: item.type,
          }
        }).href,
        '_blank' // 新窗口
      );
    },

    // 时间处理
    filterTimeYear(time) {
      return time.split(" ")[0].split("-")[0];
    },

    filterTimeMonth(time) {
      return time.split(" ")[0].split("-")[1];
    },

    filterTimeDay(time) {
      return time.split(" ")[0].split("-")[2];
    },
    // 跳转页面
    goPage(path) {
      window.open(
        this.$router.resolve({
          path: path,
        }).href,
        '_blank' // 新窗口
      );
    },
    // 查看新闻详情
    toAllGraph() {
      window.open(
        this.$router.resolve({
          path: '/industryMap',
        }).href,
        '_blank' // 新窗口
      );
    },
  },
};
</script>

<style scoped lang="scss">
.carousel {
  // padding-top: 80px;
  height: 100vh;
  background: url("@/assets/images/banner.png") no-repeat center;
  background-size: cover;
}

.carousel_top_title {
  font-weight: bold;
  font-size: 72px;
  color: #ffffff;
  padding-top: 200px;
}

.carousel_text {
  font-weight: 500;
  font-size: 29px;
  color: #ffffff;
  margin-top: 73px;
}

.carousel_btn {
  width: 196px;
  height: 57px;
  background: #238afe;
  border-radius: 26px;
  font-size: 22px;
  color: #ffffff;
  margin-top: 54px;
}

.slide_icon {
  position: absolute;
  top: 80vh;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90px;
  height: 155px;
  margin: 0 auto;
  padding-top: 5vh;
}

.slide_icon img {
  width: 70px;
  height: 170px;
  object-fit: contain;
}

.shake {
  animation: shake 2.5s;
  animation-iteration-count: infinite;
}

.no-select {
  user-select: none;
  /* 禁止文本选择 */
  pointer-events: none;
  /* 禁止鼠标事件（无法点击、拖动等） */
  -webkit-user-drag: none;
  /* 禁止 WebKit 浏览器拖动 */
  cursor: default;
  /* 更改鼠标样式，避免误导 */
}

@keyframes shake {
  0% {
    transform: translateY(0);
  }

  25% {
    transform: translateY(-10px);
  }

  50% {
    transform: translateY(10px);
  }

  75% {
    transform: translateY(-10px);
  }

  100% {
    transform: translateY(10px);
  }
}

.column_title_box {
  padding-top: 150px;
}

.title_name {
  font-size: 48px;
  font-weight: 600;
  letter-spacing: 5px;
}

.title_txt {
  font-size: 32px;
  font-weight: bold;
}

.graph_btn {
  margin-top: 150px;
  width: 163px;
  height: 49px;
  border-radius: 8px;
  border: 2px solid #ffffff;
  font-size: 20px;
  color: #ffffff;
}

// 产品介绍
.home_main_first {
  height: 100vh;
  background: url("@/assets/images/bg02.png") no-repeat center;
  background-size: cover;
}

.first_main {
  margin-top: 50px;
}

.first_main_left {
  width: 600px;
}

.first_left_title {
  font-weight: bold;
  font-size: 30px;
  color: #333333;
}

.first_left_text {
  font-size: 22px;
  color: #333333;
  margin-top: 26px;
  margin-bottom: 124px;
}

.first_left_list_tabs {
  position: relative;
  z-index: 1;
}

.left_list_tabs_box {
  font-weight: bold;
  font-size: 20px;
  color: #333333;
  margin-right: 58px;
}

.left_list_tabs_box_select {
  font-weight: bold;
  font-size: 20px;
  color: #284187;
  margin-right: 58px;
}

.tabs_box_line {
  width: 100%;
  height: 2px;
  // background: #999999;
  margin-top: 17px;
}

.tabs_box_line_select {
  width: 100%;
  height: 2px;
  background: #284187;
  margin-top: 17px;
}

.left_number_box {
  position: relative;
  margin-top: -2px;
  width: 100%;
  border-top: 2px solid #999999;
  padding-top: 68px;
}

.left_number_num {
  font-weight: 600;
  font-size: 60px;
  color: #284187;
}

.left_number_num span {
  font-weight: 600;
  font-size: 30px;
  color: #284187;
}

.left_number_text {
  font-size: 18px;
  color: #333333;
}

.first_main_right {
  width: 549px;
  height: 549px;
  border-radius: 50%;
}

.right_img_two {
  position: relative;
  margin-left: -120px;
  padding-top: 20px;
}

// 产业图谱
.home_main_two {
  height: 100vh;
  background: url("@/assets/images/home03.png") no-repeat center;
  background-size: cover;
}

// 产业发展规模
.home_main_three {
  height: 100vh;
  background: url("@/assets/images/bg04.png") no-repeat center;
  background-size: cover;
}

.scale_list {
  margin-top: 80px;
}

.scale_box {
  margin: 0 40px;
}

.scale_num {
  // font-weight: 600;
  font-size: 45px;
  color: #284187;
  font-family: Impact;
}

.scale_num span {
  font-size: 23px;
  color: #284187;
}

.scale_name {
  font-size: 18px;
  color: #333333;
}

.select_year_box {
  position: relative;
  font-size: 293px;
  color: #2567F1;
  line-height: 293px;
  opacity: 0.2;
  font-weight: 800;
  text-align: center;
  margin-top: 50px;
  margin-bottom: -160px;
  font-family: Impact;
}

.left_time_line {
  width: 250px;
  height: 1px;
  background: linear-gradient(90deg, rgba(40, 65, 135, 0) 0%, #284187 100%, );
}

.right_time_line {
  width: 250px;
  height: 1px;
  background: linear-gradient(90deg, #284187 0%, rgba(40, 65, 135, 0.07) 100%);
}

.time_line_main {
  width: 1280px;
  margin: 0 5px;
}

.time_line_btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #284187;
  font-size: 20px;
  color: #284187;
}

.center_time_line {
  width: 1190px;
  height: 1px;
  background-color: #284187;
  margin: 0 5px;
}

.time_line_list {
  width: 1000px;
  margin: 0 auto;
  position: relative;
  margin-top: -26px;
}

.time_line_box {
  margin: 0 42px;
}

.time_line_drop {
  width: 9px;
  height: 9px;
  background: #8791B0;
  border-radius: 50%;
}

.time_line_drop_select {
  width: 9px;
  height: 9px;
  background: #284187;
  border-radius: 50%;
}

.time_line_year {
  font-weight: 600;
  font-size: 18px;
  color: #8791B0;
  margin-top: 20px;
}

.time_line_year_select {
  font-weight: 600;
  font-size: 18px;
  color: #284187;
  margin-top: 20px;
}


.bidding_hall_list {
  height: 399px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none; // 滚动条隐藏
  }
}

// 产业新闻
.home_main_four {
  height: 100vh;
  background: url("@/assets/images/bg05.png") no-repeat center;
  background-size: cover;
}

.news_list {
  margin-top: 65px;
}

.news_box {
  width: 414px;
}

.news_title_box {
  border-bottom: 2px solid #FFFFFF;
  padding-bottom: 36px;
}

.news_title {
  width: 300px;
  font-size: 20px;
}

.news_text_box {
  position: relative;
  margin-top: -2px;
}

.new_line {
  width: 67px;
  height: 2px;
  background: #fff;
  border-radius: 1px;
  margin-bottom: 30px;
}

.new_line_select {
  width: 67px;
  height: 2px;
  background: #238AFE;
  border-radius: 1px;
  margin-bottom: 30px;
}

.news_content {
  font-size: 16px;
  color: #BFBFBF;
  height: 70px;
}

.news_img {
  width: 100%;
  height: 282px;
  background: #FFFFFF;
  border-radius: 12px;
  margin-top: 37px;
}

.news_img img {
  width: 100%;
  height: 282px;
  background: #FFFFFF;
  border-radius: 12px;
  object-fit: cover;
}

// 产业大事记
.home_main_five {
  padding-bottom: 100px;
  background: #ffffff;
}

.memorabilia_tabs_list {
  margin-top: 53px;
  margin-bottom: 20px;
}

.memorabilia_tabs_box {
  padding: 6px 10px;
  border: 2px solid #fff;
  font-size: 18px;
  color: #999999;
  margin-left: 30px;
}

.memorabilia_tabs_select {
  padding: 6px 10px;
  border: 2px solid #284086;
  font-size: 18px;
  color: #284187;
  margin-left: 30px;
}

.poetry-timeline-container {
  width: 100%;
  margin: 0 auto;
  padding: 50px 0;
}

.timeline_head {
  width: 15px;
  height: 15px;
  // background: linear-gradient(0deg, #238AFE 0%, #02A9FF 100%);
  border-radius: 50%;
  border: 4px solid #238AFE;
  margin: 0 auto;
}

.timeline-item {
  display: flex;
  align-items: center;
  height: 233px;
  width: 100%;
}

.left-poetry {
  width: 520px;
  text-align: right;
  padding-right: 120px;
}

.right-poetry {
  width: 560px;
  text-align: left;
  padding-left: 80px;
}

.poetry-year {
  font-weight: 800;
  font-size: 76px;
  color: #284086;
  font-family: Alibaba-PuHuiTi-H;
}

.poetry_title {
  width: 400px;
  font-weight: bold;
  font-size: 30px;
  color: #284187;
  margin-bottom: 20px;
}

.poetry-content {
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  margin-bottom: 10px;
}

.timeline-line {
  width: 2px;
  height: 100%;
  position: relative;
  background-color: #238AFE;
}

.full-line {
  width: 1px;
  height: 100%;
  background-color: #0E287C;
}

.full-line::before {
  content: "";
  width: 7px;
  height: 7px;
  background: #0E287C;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: -3px;
  transform: translateY(-50%);
}
</style>
